import { createFileRoute, notFound } from "@tanstack/react-router";
import BlogPost from "@/pages/BlogPost";
import { blogPostQuery } from "@/lib/publicQueries";
import { clip, seoHead } from "@/lib/seo";

export const Route = createFileRoute("/blog/$slug")({
  loader: async ({ context, params }) => {
    let post;
    try {
      post = await context.queryClient.ensureQueryData(blogPostQuery(params.slug));
    } catch (err) {
      console.error("Blog post loader failed:", err);
      return { seo: null };
    }
    if (!post) throw notFound();
    return {
      seo: {
        title: post.seo_title || post.title,
        description: post.seo_description || post.excerpt || "",
        image: post.featured_image ?? null,
      },
    };
  },
  head: ({ loaderData, params }) => {
    const seo = loaderData?.seo;
    if (!seo) {
      return {
        meta: [{ title: "Artikel | Clicks DMP" }, { name: "robots", content: "noindex" }],
      };
    }
    const suffix = " | Clicks DMP";
    const base = seo.title.replace(/\s*[|–-]\s*Clicks DMP\s*$/i, "");
    const title = clip(base, 60 - suffix.length) + suffix;
    return seoHead({
      title,
      description: clip(seo.description || seo.title, 155),
      path: `/blog/${params.slug}`,
      image: seo.image,
      type: "article",
    });
  },
  component: BlogPost,
});
